import { Trial_Status, useTrialHeaderQuery, useViewTrialMutation } from "@generated/graphql";
import Box from "@mui/material/Box";
import CircularLoading from "components/CircularLoading";
import useIsCreate from "hooks/useIsCreate";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import TestingContent from "./components/Content";
import PersonalHeader from "./components/Header";

const TestingView = () => {
  const isCreate = useIsCreate();
  const { id } = useParams();

  const {
    data,
    loading,
    refetch: refetchTrialHeader,
  } = useTrialHeaderQuery({
    variables: {
      trialId: id!,
    },
    skip: !id,
  });
  const [viewTrial] = useViewTrialMutation();
  const trial = data?.trial;

  const shouldMarkAsViewed =
    !!id &&
    trial?.isViewed === false &&
    (trial.status === Trial_Status.Completed || trial.status === Trial_Status.Canceled);

  useEffect(() => {
    if (!shouldMarkAsViewed) return;

    viewTrial({
      variables: { trialId: id! },
      optimisticResponse: { viewTrial: true },
      update: (cache) => {
        const trialCacheId = cache.identify({ __typename: "Trial", id });

        if (!trialCacheId) return;

        cache.modify({
          id: trialCacheId,
          fields: {
            isViewed: () => true,
          },
        });
      },
    });
  }, [id, shouldMarkAsViewed, viewTrial]);

  if (loading) return <CircularLoading />;

  return (
    <Box>
      <PersonalHeader trial={trial} />
      <TestingContent
        trial={trial}
        isCreate={isCreate}
        refetchTrialHeader={refetchTrialHeader}
      />
    </Box>
  );
};
export default TestingView;
